import { createFileRoute } from '@tanstack/react-router';

import { PickupScreenBayWa } from '~/modules/pickupScreen';

export const Route = createFileRoute('/(custom)/pickup')({
  component: PickupScreenBayWa,
});
